module.exports = __webpack_public_path__ + "gy.svg?f67dfeb2568434e36079f7bbf9721247";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gy.svg
// module id = 827
// module chunks = 27